module.exports = __webpack_public_path__ + "img/vertical_4_1_5010.1a7df176.png";